import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/categories.json";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import { CategoryAttributeItem, CategoryModel } from "../models/CategoryModel";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { Link } from "react-router-dom";
import { DataTable, DataTableCustomActions, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import DataTableActiveToggle from "../../../components/data/DataTableActiveToggle";
import Modal from "../../../components/base/Modal";
import TextBox from "../../../components/form/TextBox";
import { toastSuccess } from "../../../components/base/Toast";
import DropDown, { DropDownOption } from "../../../components/form/DropDown";
import Tagify from "../../../components/tagify/Tagify";
import TextArea from "../../../components/form/TextArea";
import Indicator from "../../../components/base/Indicator";
import { DrawerForm } from "../../../components/drawers/DrawerForm";
import Div from "../../../components/base/Div";
import DataItem from "../../../models/DataItem";
import { getRandomString } from "../../../core/Helper";
import IconButton from "../../../components/base/IconButton";

export default function CategoryListView() {

  const hub = useHub()
  const user = getUser()

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)
  const [deleteRes, deleteResSet] = useState<any>()

  const [attributesModal, attributesModalSet] = useState<boolean>(false)
  const [attsLoading, attsLoadingSet] = useState<boolean>(false)
  const [attsLoaded, attsLoadedSet] = useState<boolean>(false)
  const [parentAtts, parentAttsSet] = useState<CategoryAttributeItem[]>([])
  const [atts, attsSet] = useState<CategoryAttributeItem[]>([])
  const [attsChanged, attsChangedSet] = useState<boolean>(false)
  const [draggedAttId, draggedAttIdSet] = useState<string>()

  const [selectedItem, selectedItemSet] = useState<CategoryModel>()
  const [refresh, refreshSet] = useState<boolean>()

  const [attTypes] = useState<DataItem[]>([
    {
      id: "1",
      name: "Text"
    },
    {
      id: "2",
      name: "Multi-Line Text"
    },
    {
      id: "3",
      name: "Numeric"
    },
    {
      id: "4",
      name: "Yes/No"
    }
  ])

  const edit = (data: any) => {
    selectedItemSet(data);
    editModalSet(true);
  }

  const deleteCategory = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: CategoryModel) => (
    <FlexRow>
      <div>
        {data.fullPathName}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )

  const AttsCount = (data: CategoryModel) => (
    <div>
      {
        (data.attributesCount ?? 0) > 0 ?
          <a href="#" className="fs-7"
            onClick={e => {
              e.preventDefault()
              attributesModalSet(true)
              selectedItemSet(data)
            }}>
            {data.attributesCount} Custom Fields
          </a>
          :
          <a href="#" className="fs-8 text-muted"
            onClick={e => {
              e.preventDefault()
              attributesModalSet(true)
              selectedItemSet(data)
            }}>
            [No Custom Field]
          </a>
      }
    </div>
  )

  const CreatedItem = (data: CategoryModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const CustomFieldsAction = (data: CategoryModel) => (
    <div className="menu-item">
      <a href="#" className="menu-link text-gray-700 px-3" onClick={async e => {
        e.preventDefault()
        attributesModalSet(true)
        selectedItemSet(data)
      }}>
        <Icon icon="file-edit" className="me-2" />
        Custom Fields
      </a>
    </div>
  )

  useEffect(() => {

    validateRole("ManageCategories");
    setPage("Categories", "Inventory", "Base Data");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Category"
          apiRoute={API_ROUTES.InventoryCategories}
          filteringProps={filteringProps}
          // sortingProps={sortingProps}
          addCustom={() => createModalSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteCategories")} deleteCustom={deleteCategory}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="Description" dataValueName="description">
          </DataTableField>

          <DataTableField title="Custom Fields">
            <AttsCount />
          </DataTableField>

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableCustomActions>
            <CustomFieldsAction />
          </DataTableCustomActions>

        </DataTable>



      {
        createModal &&
        <DrawerForm id="drawer-add-category"
          title="Create Category"
          buttonText="Add Categories"
          onClose={() => createModalSet(false)}
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.names) || body.names.length < 2) {
              window.formError("names", "Please write a valid name!", "drawer-add-category", true);
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.InventoryCategories, body, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Categories has been added successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>

            <DropDown id="create-cat-parent" name="parentId" label="Parent" forceSelectValue="root"
              labelUp block marginBottom={5} parentModal="drawer-add-category" deselect={false}
              apiSource={API_ROUTES.TagifyCategories} dataText="title" dataValue="value" />

            <Tagify id="create-cat-names" name="names" label="Name(s)" marginBottom={5}
              parentId="drawer-add-category" labelUp block freeTags />

            <TextArea id="create-cat-descr" name="description"
              label="Description" labelUp block rows={6}
              placeholder="Write a description (optional)" />

          </div>
        </DrawerForm>
      }

      {
        editModal && selectedItem &&
        <DrawerForm id="drawer-edit-category"
          title="Edit Category"
          buttonText="Update Category"
          onClose={() => {
            editModalSet(false);
            selectedItemSet(undefined);
          }}
          onOpen={() => $("#edit-cat-name").focus()}
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "drawer-edit-category", true);
              if (callback) callback();
              return;
            }

            hub.Put(API_ROUTES.InventoryCategories, {
              ...body,
              id: selectedItem.id,
              parentId: body.parentId,
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Category has been updated successfully!");
              }
              if (callback) callback(res);
            })

          }}>

          <DropDown id="edit-cat-parent" name="parentId" label="Parent" forceSelectValue={(selectedItem.parentId ? selectedItem.parentId : "root")}
            labelUp block marginBottom={5} parentModal="drawer-edit-category" deselect={false}
            apiSource={API_ROUTES.TagifyCategories} dataText="title" dataValue="value" />

          <TextBox id="edit-cat-name" name="name" label="Name" marginBottom={5}
            value={selectedItem.name} labelUp block />

          <TextArea id="edit-cat-descr" name="description"
            label="Description" labelUp block rows={6} value={selectedItem.description}
            placeholder="Write a note (optional)" />


        </DrawerForm>
      }

      {
        attributesModal && selectedItem &&
        <DrawerForm id="drawer-edit-category-attributes"
          title={`${selectedItem.name} : Custom Fields`}
          buttonText="Update Custom Fields"
          hideButtons={attsLoading || !attsChanged}
          onClose={() => {
            attributesModalSet(false);
            selectedItemSet(undefined);
          }}
          onOpen={() => {
            attsLoadedSet(false)
            attsLoadingSet(true)
            attsChangedSet(false)

            hub.Get(`${API_ROUTES.InventoryCategories}attributes/${selectedItem.id}`, res => {
              attsSet(res.data.atts)
              parentAttsSet(res.data.parentAtts)
              attsLoadingSet(false)
              attsLoadedSet(true)
              attsChangedSet(false)
            })


          }}
          onSubmit={(body, callback) => {

            var valid = true;
            var focus = true;
            for (var i = 0; i < atts.length; i++) {
              var att = atts[i]

              if (window.isNullOrEmpty(att.name) || att.name!.length < 2) {
                window.formError(`name-${att.id}`, "Please write a valid name!", "drawer-edit-category-attributes", focus, false, false);
                valid = false;
                focus = false;
              }

              if (!att.type) {
                window.formError(`type-${att.id}`, "Please select a type!", "drawer-edit-category-attributes", focus, false, false);
                valid = false;
                focus = false;
              }

            }

            if (!valid) {
              callback!()
              return;
            }


            hub.Post(`${API_ROUTES.InventoryCategories}attributes/${selectedItem.id}`, atts, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Category custom fields has been updated successfully!");
              }
              callback!(res);
            })

          }}>



          <Div visible={attsLoading} className="py-10">
            <Indicator />
          </Div>

          <Div visible={attsLoaded}>

            {
              parentAtts.length > 0 &&
              <h3 className="border-bottom">Parent Fields</h3>
            }

            {
              parentAtts.map((att, k) =>
                <div className="row border-bottom py-3" key={k}>
                  <div className="col-12 col-lg-5">
                    <TextBox block placeholder="Name" marginBottom={0} value={att.name} readOnly disabled />
                  </div>
                  <div className="col-12 col-lg-5">
                    <DropDown block placeholder="Choose Type" marginBottom={0} disabled deselect={false}
                      source={attTypes} parentModal="drawer-edit-category-attributes" forceSelectValue={att.type?.toString()} />
                  </div>
                  <div className="col-12 col-lg-2">

                  </div>
                </div>
              )
            }

            {
              parentAtts.length > 0 &&
              <h3 className="border-bottom mt-10">Category Fields</h3>
            }


            {
              atts.map((att, k) =>
                <div
                  className="row border-bottom py-3 align-items-center"
                  key={att.id}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                  onDrop={() => {
                    if (!draggedAttId || draggedAttId === att.id) return;

                    attsSet(prev => {
                      const draggedIndex = prev.findIndex(x => x.id === draggedAttId);
                      const dropIndex = prev.findIndex(x => x.id === att.id);

                      if (draggedIndex === -1 || dropIndex === -1) return prev;

                      const updated = [...prev];
                      const [draggedItem] = updated.splice(draggedIndex, 1);
                      updated.splice(dropIndex, 0, draggedItem);

                      return updated;
                    });

                    attsChangedSet(true);
                    draggedAttIdSet("");
                  }}
                >
                  <div
                    className="col-auto pe-0"
                    draggable
                    onDragStart={() => {
                      draggedAttIdSet(att.id);
                    }}
                    onDragEnd={() => {
                      draggedAttIdSet("");
                    }}
                    style={{ cursor: "move" }}
                  >
                    <IconButton
                      icon="grip-lines"
                      type="solid"
                      title="Drag to reorder"
                      size={16}
                      gap={10}
                      className="cursor-move text-muted bg-light"
                    />
                  </div>
                  <div className="col-12 col-lg-5">
                    <TextBox name={`name-${att.id}`} block placeholder="Name" marginBottom={0} value={att.name}
                      onTextChanges={t => {
                        attsChangedSet(true)
                        attsSet(prev => prev.map(item => item.id === att.id ? { ...item, name: t } : item))
                    }} />
                  </div>
                  <div className="col-12 col-lg-4">
                    <DropDown name={`type-${att.id}`} block placeholder="Choose Type" marginBottom={0}
                      source={attTypes} parentModal="drawer-edit-category-attributes" forceSelectValue={att.type?.toString()}
                      onSelect={t => {
                        attsChangedSet(true)
                        attsSet(prev => prev.map(item => item.id === att.id ? { ...item, type: Number.parseInt(t ?? "1") } : item))
                    }}
                    onClear={() => {
                      attsChangedSet(true)
                      attsSet(prev => prev.map(item => item.id === att.id ? { ...item, type: undefined } : item))
                  }}/> 
                  </div>
                  <div className="col-12 col-lg-2">
                    <button type="button" className="btn btn-sm btn-light-danger btn-active-light-danger w-100"
                      onClick={e => {
                        e.preventDefault()
                        attsChangedSet(true)
                        attsSet(prev => prev.filter(item => item.id !== att.id));
                      }}>
                      <Icon icon="minus" />
                      Remove
                    </button>
                  </div>
                </div>
              )
            }

            <div className="mt-5 mb-10">
              <button type="button" className="btn btn-sm btn-light-primary btn-active-light-primary w-100"
                onClick={e => {
                  e.preventDefault()
                  attsChangedSet(true)
                  attsSet(prev => [...prev, {
                    id: `new-${getRandomString(5)}`
                  }])
                }}>
                <Icon icon="plus" />
                Add Custom Field
              </button>
            </div>

          </Div>


        </DrawerForm>
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-category"
          title="Delete Category"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onOpen={() => {
            hub.Post(API_ROUTES.InventoryCategories + "verifydelete", {
              id: selectedItem.id
            }, res => deleteResSet(res.data))
          }}
          onClose={() => {
            deleteModalSet(false)
            deleteResSet(undefined)
            selectedItemSet(undefined)
          }}
          onSubmit={deleteRes ? (body, callback) => {

            hub.Post(API_ROUTES.InventoryCategories + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Category has been deleted successfully!");
              }
              callback!(res);
            })

          } : undefined}
          staticBackdrop open visible>
          <div>

            {
              deleteRes ?
                <div>
                  {
                    deleteRes.childsCount > 0 ?
                      <div>
                        <div className="mb-2">
                          There {deleteRes.childsCount > 1 ? "are" : "is"} {deleteRes.childsCount} child {deleteRes.childsCount > 1 ? "categories" : "category"} related to this category!
                        </div>
                        <div className="alert alert-danger">
                          {selectedItem.fullPathName}
                        </div>
                        <DropDown label="You need to perform an action"
                          id="delete-cat-action" name="action"
                          block labelUp deselect={false} parentModal="modal-delete-category"
                          source={[
                            {
                              id: "1",
                              name: "Delete all childs"
                            },
                            {
                              id: "2",
                              name: "Assign to another category"
                            }
                          ]}>
                        </DropDown>

                        <DropDown id="delete-cat-parent" name="parentId" label="Assign to"
                          labelUp block marginBottom={5} parentModal="modal-delete-category"
                          apiSource={API_ROUTES.TagifyCategories} dataText="title" dataValue="value" />

                      </div>
                      :
                      <>
                        <div className="mb-2">
                          Are you sure you want to delete the category?
                        </div>
                        <div className="alert alert-danger">
                          {selectedItem.fullPathName}
                        </div>
                      </>
                  }
                </div>
                :
                <div className="py-10">
                  <Indicator text="Please wait..." />
                </div>
            }



          </div>
        </Modal>
      }


    </>
  );
}
